/**
 * 素ヱコ農園 ギフトオプション
 * のし・手提げ袋の選択UI制御
 * のし選択時に Cart Note Attributes へ 熨斗/熨斗の種類/表書/名前 を書き込む
 * のしの種類・表書きはカスタムドロップダウン（太字値 + グレー説明）
 */
(function() {
  'use strict';

  // --- 表書きプリセット（のしの種類別） ---
  var OMOTEGAKI_OPTIONS = {
    '蝶結び': [
      { value: '御祝', desc: 'お祝い全般' },
      { value: '内祝', desc: 'お返し全般' },
      { value: '御礼', desc: 'お礼・感謝' },
      { value: 'お中元', desc: '夏のご挨拶' },
      { value: 'お歳暮', desc: '冬のご挨拶' },
      { value: 'お年賀', desc: '年始のご挨拶' },
      { value: '御挨拶', desc: 'ご挨拶全般' },
      { value: '出産祝', desc: 'ご出産のお祝い' },
      { value: '出産内祝', desc: '出産祝いのお返し' },
      { value: '入学祝', desc: '入学のお祝い' },
      { value: '卒業祝', desc: '卒業のお祝い' },
      { value: '新築祝', desc: '新築・引越しのお祝い' }
    ],
    '結び切り': [
      { value: '寿', desc: '結婚祝い' },
      { value: '結婚内祝', desc: '結婚祝いのお返し' },
      { value: '快気祝', desc: '病気回復のお祝い' },
      { value: '快気内祝', desc: 'お見舞いのお返し' },
      { value: '御見舞御礼', desc: 'お見舞いへのお礼' }
    ],
    '掛け紙（法事用など）': [
      { value: '志', desc: '香典返し・法事のお返し' },
      { value: '御仏前', desc: '法事のお供え' },
      { value: '御霊前', desc: '通夜・葬儀のお供え' },
      { value: '御供', desc: 'お供え物' },
      { value: '粗供養', desc: '法事の引き出物' }
    ],
    '熨斗シール（お歳暮）': [
      { value: 'お歳暮', desc: '冬のご挨拶' },
      { value: 'お中元', desc: '夏のご挨拶' },
      { value: '御礼', desc: 'お礼・感謝' },
      { value: 'ほんの気持ち', desc: 'カジュアルなギフト' }
    ]
  };

  document.querySelectorAll('.gift-options-wrapper').forEach(function(wrapper) {
    var trigger = wrapper.querySelector('.gift-options__trigger');
    var panel = wrapper.querySelector('.gift-options__panel');
    var giftFlag = wrapper.querySelector('[data-gift-flag]');

    if (!trigger || !panel) return;

    // --- のしの種類カスタムドロップダウン要素 ---
    var noshiDropdown = wrapper.querySelector('[data-noshi-dropdown]');
    var noshiBtn = wrapper.querySelector('[data-noshi-btn]');
    var noshiLabel = wrapper.querySelector('[data-noshi-label]');
    var noshiList = wrapper.querySelector('[data-noshi-list]');
    var noshiHidden = wrapper.querySelector('[data-noshi-value]');
    var noshiVariantHidden = wrapper.querySelector('[data-noshi-variant-id]');

    // --- 表書きカスタムドロップダウン要素 ---
    var omotegakiDropdown = wrapper.querySelector('[data-omotegaki-dropdown]');
    var omotegakiBtn = wrapper.querySelector('[data-omotegaki-btn]');
    var omotegakiLabel = wrapper.querySelector('[data-omotegaki-label]');
    var omotegakiList = wrapper.querySelector('[data-omotegaki-list]');
    var omotegakiHidden = wrapper.querySelector('[data-omotegaki-value]');

    // 現在選択中ののしの種類
    var currentNoshiType = '';

    // --- ギフトパネル開閉 ---
    trigger.addEventListener('click', function() {
      var isOpen = !panel.hidden;
      panel.hidden = isOpen;
      trigger.setAttribute('aria-expanded', String(!isOpen));
      trigger.querySelector('span').textContent =
        isOpen ? 'ギフトオプションを選択' : 'ギフトオプションを閉じる';

      if (isOpen) {
        resetAll(wrapper);
        if (giftFlag) giftFlag.disabled = true;
        updateNoteAttributes({ '熨斗': '', '熨斗の種類': '', '表書': '', '名前': '' });
      } else {
        if (giftFlag) giftFlag.disabled = false;
      }
    });

    // --- 各セクションの開閉トグル ---
    wrapper.querySelectorAll('.gift-options__toggle').forEach(function(toggle) {
      var targetId = toggle.getAttribute('data-target');
      var isSimple = toggle.hasAttribute('data-simple-prop');

      toggle.addEventListener('change', function() {
        if (targetId) {
          var details = document.getElementById(targetId);
          if (details) {
            details.hidden = !this.checked;
            details.querySelectorAll('input, select').forEach(function(el) {
              el.disabled = !toggle.checked;
            });
            // カスタムドロップダウンのボタンも連動
            if (noshiBtn) noshiBtn.disabled = !this.checked;
            if (omotegakiBtn) omotegakiBtn.disabled = true; // のし種類選択前は無効
          }
          if (!this.checked) {
            clearSection(details);
            currentNoshiType = '';
            resetNoshi();
            resetOmotegaki();
            if (targetId.indexOf('noshi') !== -1) {
              updateNoteAttributes({ '熨斗': '', '熨斗の種類': '', '表書': '', '名前': '' });
            }
          }
        }

        if (isSimple) {
          var bagInput = wrapper.querySelector('[data-bag-value]');
          if (bagInput) {
            bagInput.value = this.checked ? 'あり' : '';
            bagInput.disabled = !this.checked;
          }
        }
      });
    });

    // --- のしの種類: カスタムドロップダウン開閉 ---
    if (noshiBtn) {
      noshiBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (this.disabled) return;
        var isOpen = !noshiList.hidden;
        noshiList.hidden = isOpen;
        this.setAttribute('aria-expanded', String(!isOpen));
        // 表書きは閉じる
        closeOmotegaki();
      });
    }

    // --- のしの種類: アイテムクリック ---
    if (noshiList) {
      noshiList.querySelectorAll('.gift-options__custom-select-item').forEach(function(li) {
        li.addEventListener('click', function() {
          var value = this.getAttribute('data-value');
          var variantId = this.getAttribute('data-variant-id') || '';

          currentNoshiType = value;
          if (noshiHidden) noshiHidden.value = value;
          if (noshiVariantHidden) noshiVariantHidden.value = variantId;
          if (noshiLabel) noshiLabel.textContent = value;

          // 選択状態の更新
          noshiList.querySelectorAll('li').forEach(function(el) {
            el.removeAttribute('aria-selected');
          });
          this.setAttribute('aria-selected', 'true');
          closeNoshi();

          // 表書きドロップダウンを更新
          buildOmotegakiList(value);
        });
      });
    }

    // --- 表書き: カスタムドロップダウン開閉 ---
    if (omotegakiBtn) {
      omotegakiBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (this.disabled) return;
        var isOpen = !omotegakiList.hidden;
        omotegakiList.hidden = isOpen;
        this.setAttribute('aria-expanded', String(!isOpen));
        // のしの種類は閉じる
        closeNoshi();
      });
    }

    // --- 外側クリックで両方閉じる ---
    document.addEventListener('click', function(e) {
      if (noshiDropdown && !noshiDropdown.contains(e.target)) {
        closeNoshi();
      }
      if (omotegakiDropdown && !omotegakiDropdown.contains(e.target)) {
        closeOmotegaki();
      }
    });

    // --- のしの種類: 閉じる/リセット ---
    function closeNoshi() {
      if (noshiList) noshiList.hidden = true;
      if (noshiBtn) noshiBtn.setAttribute('aria-expanded', 'false');
    }

    function resetNoshi() {
      if (noshiHidden) noshiHidden.value = '';
      if (noshiVariantHidden) noshiVariantHidden.value = '';
      if (noshiLabel) noshiLabel.textContent = '選択してください';
      if (noshiList) {
        noshiList.querySelectorAll('li').forEach(function(el) {
          el.removeAttribute('aria-selected');
        });
        noshiList.hidden = true;
      }
      if (noshiBtn) noshiBtn.setAttribute('aria-expanded', 'false');
    }

    // --- 表書き: リスト構築 ---
    function buildOmotegakiList(noshiType) {
      if (!omotegakiList) return;
      omotegakiList.innerHTML = '';
      resetOmotegaki();

      var options = OMOTEGAKI_OPTIONS[noshiType];
      if (!options || options.length === 0) {
        if (omotegakiLabel) omotegakiLabel.textContent = 'のしの種類を先に選択してください';
        if (omotegakiBtn) omotegakiBtn.disabled = true;
        return;
      }

      if (omotegakiLabel) omotegakiLabel.textContent = '選択してください';
      if (omotegakiBtn) omotegakiBtn.disabled = false;

      options.forEach(function(item) {
        var li = document.createElement('li');
        li.className = 'gift-options__custom-select-item';
        li.setAttribute('role', 'option');
        li.setAttribute('data-value', item.value);
        li.innerHTML =
          '<span class="gift-options__custom-select-item-value">' + item.value + '</span>' +
          '<span class="gift-options__custom-select-item-desc">（' + item.desc + '）</span>';

        li.addEventListener('click', function() {
          selectOmotegaki(item.value);
          omotegakiList.querySelectorAll('li').forEach(function(el) {
            el.removeAttribute('aria-selected');
          });
          li.setAttribute('aria-selected', 'true');
          closeOmotegaki();
        });

        omotegakiList.appendChild(li);
      });
    }

    function selectOmotegaki(value) {
      if (omotegakiHidden) omotegakiHidden.value = value;
      if (omotegakiLabel) omotegakiLabel.textContent = value;
    }

    function closeOmotegaki() {
      if (omotegakiList) omotegakiList.hidden = true;
      if (omotegakiBtn) omotegakiBtn.setAttribute('aria-expanded', 'false');
    }

    function resetOmotegaki() {
      if (omotegakiHidden) omotegakiHidden.value = '';
      if (omotegakiLabel) omotegakiLabel.textContent = 'のしの種類を先に選択してください';
      if (omotegakiList) {
        omotegakiList.innerHTML = '';
        omotegakiList.hidden = true;
      }
      if (omotegakiBtn) {
        omotegakiBtn.setAttribute('aria-expanded', 'false');
        omotegakiBtn.disabled = true;
      }
    }

    // --- のし商品をカートに自動追加 + Note Attributes 更新 ---
    var form = wrapper.closest('form[action*="/cart/add"]') || wrapper.closest('form');
    if (form) {
      form.addEventListener('submit', function(e) {
        var variantId = noshiVariantHidden ? noshiVariantHidden.value : '';

        if (variantId) {
          e.preventDefault();
          var formData = new FormData(form);

          var properties = {};
          formData.forEach(function(value, key) {
            if (key.startsWith('properties[')) {
              var propName = key.replace('properties[', '').replace(']', '');
              if (value) properties[propName] = value;
            }
          });

          var rawId = formData.get('id');
          var mainItemId = rawId ? parseInt(rawId, 10) : NaN;
          if (isNaN(mainItemId)) {
            form.submit();
            return;
          }
          var mainQty = parseInt(formData.get('quantity'), 10) || 1;

          // Note Attributes 用のデータ
          var noshiType = currentNoshiType;
          var omoteGaki = omotegakiHidden ? omotegakiHidden.value : '';
          var naire = formData.get('properties[名入れ]') || '';

          // 1. メイン商品をカートに追加
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: mainItemId,
                quantity: mainQty,
                properties: properties
              }]
            })
          })
          .then(function(response) {
            if (!response.ok) throw new Error('メイン商品の追加に失敗しました');
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{ id: parseInt(variantId, 10), quantity: 1 }]
              })
            });
          })
          .then(function(response) {
            if (!response.ok) throw new Error('のし商品の追加に失敗しました');
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                attributes: {
                  '熨斗': '有',
                  '熨斗の種類': noshiType,
                  '表書': omoteGaki,
                  '名前': naire
                }
              })
            });
          })
          .then(function(response) {
            if (!response.ok) throw new Error('Note Attributes の更新に失敗しました');
            window.location.href = '/cart';
          })
          .catch(function(err) {
            console.error('カート追加エラー:', err);
            alert('カートへの追加中にエラーが発生しました。ページを再読み込みしてもう一度お試しください。');
          });
        }
      });
    }
  });

  // --- Cart Note Attributes を更新 ---
  function updateNoteAttributes(attrs) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function(err) {
      console.error('Note Attributes 更新エラー:', err);
    });
  }

  // --- ユーティリティ ---
  function resetAll(wrapper) {
    wrapper.querySelectorAll('.gift-options__toggle').forEach(function(toggle) {
      toggle.checked = false;
      var targetId = toggle.getAttribute('data-target');
      if (targetId) {
        var details = document.getElementById(targetId);
        if (details) {
          details.hidden = true;
          clearSection(details);
        }
      }
    });
    var bagInput = wrapper.querySelector('[data-bag-value]');
    if (bagInput) { bagInput.value = ''; bagInput.disabled = true; }
  }

  function clearSection(container) {
    if (!container) return;
    container.querySelectorAll('input[type="text"]').forEach(function(el) {
      el.value = '';
      el.disabled = true;
    });
    container.querySelectorAll('select').forEach(function(el) {
      el.selectedIndex = 0;
      el.disabled = true;
    });
    container.querySelectorAll('input[type="hidden"]').forEach(function(el) {
      el.value = '';
    });
  }
})();
